"use strict";
module.exports = require("./globalizacao");
